export function customerPriorityMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      customerPriorityId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateCustomerPriorityId(json) {
  return {
    data: {...json, id: json.objectId,customerPriorityId:json.objectId},
  };
}
export function fixGetManyCustomerPriority(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateCustomerPriorityId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function customerPriorityMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, customerPriorityId: json.result.objectId},
  };
}